// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberModelResponse {
    static getAttributeTypeMap() {
        return PrescriberModelResponse.attributeTypeMap;
    }
}
PrescriberModelResponse.discriminator = undefined;
PrescriberModelResponse.additionalProperties = false;
PrescriberModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PrescriberModel"
    },
];
//# sourceMappingURL=prescriberModelResponse.js.map